export default "__VITE_ASSET__CQ2w5E6H__"